import { RefreshCw, Search } from 'lucide-react';

export type SortOption = 'name' | 'city' | 'shipments' | 'recent';
export type ShipmentFilter = 'all' | 'shipped' | 'not_shipped';

interface AddressToolbarProps {
  syncing: boolean;
  syncCursor: string | null;
  onSync: () => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  shipmentFilter: ShipmentFilter;
  onShipmentFilterChange: (value: ShipmentFilter) => void;
  sortBy: SortOption;
  onSortChange: (value: SortOption) => void;
}

const FILTERS: { value: ShipmentFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'shipped', label: 'Shipped' },
  { value: 'not_shipped', label: 'Not shipped' },
];

function AddressToolbar({
  syncing,
  syncCursor,
  onSync,
  searchQuery,
  onSearchChange,
  shipmentFilter,
  onShipmentFilterChange,
  sortBy,
  onSortChange,
}: AddressToolbarProps) {
  return (
    <div className="card-toolbar">
      <div className="field-search" style={{ width: '220px' }}>
        <Search size={12} aria-hidden="true" />
        <input
          type="text"
          placeholder="Search addresses…"
          aria-label="Search saved addresses"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="segmented" role="group" aria-label="Filter by shipment status">
        {FILTERS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`seg-btn ${shipmentFilter === option.value ? 'active' : ''}`}
            aria-pressed={shipmentFilter === option.value}
            onClick={() => onShipmentFilterChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>

      <select
        className="select-compact"
        aria-label="Sort saved addresses"
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value as SortOption)}
      >
        <option value="name">Sort · Name</option>
        <option value="city">Sort · City</option>
        <option value="shipments">Sort · Most shipments</option>
        <option value="recent">Sort · Recently shipped</option>
      </select>

      <button
        className={`btn btn-secondary btn-small ${syncing ? 'loading' : ''}`}
        style={{ marginLeft: 'auto' }}
        onClick={onSync}
        disabled={syncing}
        title="Import addresses from shipment history"
      >
        <RefreshCw size={12} />
        {syncing ? 'Syncing…' : syncCursor ? 'Continue sync' : 'Sync from orders'}
      </button>
    </div>
  );
}

export default AddressToolbar;
